import { useSortable } from '@dnd-kit/react/sortable';
import React from 'react';

import Card from './Card';

export const BranchCreateItem = ({ item, index, setData }) => {
  const id = item.guid;
  const { ref } = useSortable({ id, index });

  return (
    <div key={item.guid} ref={ref}>
      <Card setData={setData} card={item} />
    </div>
  );
};
